import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../services/permissions.service';

@Injectable()
export class LicenseInterceptor implements HttpInterceptor {
  private readonly permissionsService = inject(PermissionsService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    for (let index = 0; index < environment.excludeUrls.length; index++) {
      const excludeUrl = environment.excludeUrls[index];
      if (req.url.includes(excludeUrl)) {
        return next.handle(req);
      }
    }

    if (!this.permissionsService.license) {
      return next.handle(req);
    }

    const requestWithLicense = req.clone({
      headers: req.headers.set('license', this.permissionsService.license),
    });

    return next.handle(requestWithLicense);
  }
}
